// highlightHelper.js
import React from "react";

export const highlightFlaggedWords = (text) => {
  if (!text) return text;

  const flaggedWords = [
    // Promissory & Exaggerated Claims
    "guarantee", "guaranteed", "promise", "promised", "always", "never",
    "certain", "certainly", "obvious", "no-brainer", "sure thing", "win-win",
    "no risk", "risk-free", "zero risk", "safe", "safety", "secure", "secured",
    "cannot lose", "infallible", "failsafe",

    // Predictions & Speculation
    "predict", "prediction", "guaranteed return", "hot", "hot stock", "hot tip",
    "on the verge", "explode", "take off", "timing the market", "bottom",
    "top",

    // Superlatives & Misleading Comparisons
    "best", "top", "greatest", "perfect", "number one", "#1", "highest",
    "leading", "superior", "fantastic", "amazing", "incredible", "outperform",
    "beat the market",

    // Urgent, Secret, or Exclusive Language
    "act now", "act fast", "don't wait", "limited time", "limited offer",
    "exclusive", "insider", "secret", "confidential", "off the record",
    "just between us", "everyone is buying", "don't miss out", "get in now",

    // Other High-Risk & Problematic Words
    "complaint", "complain", "unhappy", "dissatisfied", "upset", "misled",
    "mislead", "mistake", "sue", "lawsuit", "problem", "confused",
    "accurate", "inaccurate", "endorsed", "commission", "affordable", "cheap"
  ];

  const regex = new RegExp(`\\b(${flaggedWords.join("|")})\\b`, "gi");
  const parts = text.split(regex);

  return (
    <span style={{ display: "inline", whiteSpace: "pre-wrap" }}>
      {parts.map((part, i) => {
        const isFlagged = flaggedWords.some(
          (word) => word.toLowerCase() === part.toLowerCase()
        );

        if (isFlagged) {
          return (
            <span
              key={i}
              style={{
                color: "red",
                textDecoration: "underline",
                fontWeight: "600",
                display: "inline",
              }}
            >
              {part}
            </span>
          );
        }

        return (
          <span key={i} style={{ display: "inline" }}>
            {part}
          </span>
        );
      })}
    </span>
  );
};
